module.exports = __webpack_public_path__ + "static/media/freestate.ef08bae3.jpg";